var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import css from '@emotion/css';
import { width, fontSize, color, space, border, borderRadius, themeGet, } from 'styled-system';
import { boxSizing } from '../../theme/system-utilities';
/**
 * @deprecated
 *
 * Use StatefulInput instead
 */
var Input = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:active,\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:active,\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  ",
    "\n"])), width, fontSize, space, boxSizing, borderRadius, border, color, themeGet('colors.gray.10'), themeGet('colors.gray.5'), function (_a) {
    var hasError = _a.hasError, colors = _a.theme.colors;
    return hasError && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), colors.sale);
});
Input.defaultProps = {
    width: 1,
    fontSize: 'fs_16',
    color: 'gray.11',
    mt: 'sp_0',
    mb: ['sp_16', null, 'sp_0'],
    px: ['sp_16', null, null, 'sp_20'],
    py: 'sp_8',
    boxSizing: 'border-box',
    border: 1,
    borderRadius: 'br_3',
};
export default Input;
var templateObject_1, templateObject_2;
